import { ReactNode, Ref } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { FieldState } from 'support/types/ui';

const spanClassByState: Record<FieldState, string> = {
  default: 'text-gray-500',
  error: '',
  warning: '',
  'pending-validation': 'text-blue-500',
};

type TrailingAddOnProps = {
  trailingAddOn?: ReactNode;
  state?: FieldState;
  show: boolean;
  disablePointerEvents?: boolean;
  ref?: Ref<HTMLDivElement>;
};

export const TrailingAddOn = ({
  trailingAddOn,
  state = 'default',
  show,
  disablePointerEvents = true,
  ref,
}: TrailingAddOnProps) => {
  return (
    <div
      ref={ref}
      className={cn(show ? 'absolute inset-y-0 right-0 flex items-center pr-3' : 'size-0', {
        'pointer-events-none': disablePointerEvents,
      })}
    >
      {show && trailingAddOn ? (
        <span
          className={cn(
            spanClassByState[state],
            'flex h-full items-center group-focus-within:text-gray-500 sm:text-sm',
          )}
        >
          {trailingAddOn}
        </span>
      ) : null}
    </div>
  );
};
